module.exports = __webpack_public_path__ + "img/l_s7.21bc2369.png";